import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import type {CompetitionViewModel} from "../../../../../domain/common/competition/models/competition-view-model";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {OddsTabModel} from "../odds.tab-model";
import {CompetitionOddsPageLinkModel} from "../../../../../containers/competition-container/pages/odds-page/models/competition-odds-page.link-model";

export class CompetitionOddsPageTabModel extends OddsTabModel {
  index: Number;
  name: String;
  entity: CompetitionViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitionViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  get linkModel(): CompetitionOddsPageLinkModel {
    const linkModel: CompetitionOddsPageLinkModel = new CompetitionOddsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.odds;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }
}
